import { readEnvVariable } from '../helpers';

export interface ISocialEnv {
  zernioApiKey: string;
  zernioWebhookSecret: string;
  bufferApiKey: string;
}

export function getSocialEnv(): ISocialEnv {
  return {
    zernioApiKey: readEnvVariable('SOCIAL_ZERNIO_API_KEY'),
    zernioWebhookSecret: readEnvVariable('SOCIAL_ZERNIO_WEBHOOK_SECRET'),
    bufferApiKey: readEnvVariable('SOCIAL_BUFFER_API_KEY'),
  };
}
